export default __webpack_public_path__ + "47de364a692f5db1d33518be8c396c3b.png";